/**
 * Archive hero interactions.
 *
 * The "Read more" toggle is rendered (or not) server-side by its length in
 * template-parts/woocommerce/archive-hero.php, avoiding the layout shift the old
 * height-measuring approach caused.
 */

/**
 * Toggle a disclosure button and the region(s) it controls, keeping the
 * `aria-expanded` state and the `expanded` class in sync.
 *
 * @param {HTMLElement}   button  The toggle button.
 * @param {HTMLElement[]} regions Elements whose `expanded` class mirrors the button state.
 */
function toggleDisclosure( button, regions ) {
	const expanded = button.getAttribute( 'aria-expanded' ) === 'true';

	button.setAttribute( 'aria-expanded', String( ! expanded ) );
	button.classList.toggle( 'expanded', ! expanded );

	regions.forEach( region => region.classList.toggle( 'expanded', ! expanded ) );
}

/**
 * Wire up the "Read more / Read less" toggle for the term description.
 */
function initExpandableText() {
	document.querySelectorAll( '.expandable-text__link' ).forEach( button => {
		const text = button.parentElement?.querySelector( '.expandable-text' );

		button.addEventListener( 'click', () => {
			toggleDisclosure( button, text ? [ text ] : [] );
		} );
	} );
}

/**
 * Wire up the mobile accordion that reveals the hidden hero content.
 */
function initMobileToggle() {
	document.querySelectorAll( '.archive-mobile-toggled-btn' ).forEach( button => {
		const hero = button.closest( '.expandable-hero' );
		const regions = hero
			? Array.from( hero.querySelectorAll( '.archive-mobile-toggled-content' ) )
			: [];

		button.addEventListener( 'click', () => {
			toggleDisclosure( button, regions );
		} );
	} );
}

function init() {
	initExpandableText();
	initMobileToggle();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
